import React from 'react'

const MCARatioAnalysisUI = ({raList}) =>
  <div id='mcaRatioAnalysis' className='g_m_top_200'>
    <span className='g_large'><b>Ratio Analysis</b></span>
    <table className='g_table'>
      <thead className='g_sticky'><tr><td />
        {
          raList.map((ra, i) =>
            <td key={i} className='g_text_right'>
              <b className='g_no_wrap'>{ra.financialYear}</b>
            </td>
          )
        }
      </tr></thead>
      <tbody>
      <tr><td colspan='8'><b>Liquidity Analysis</b></td></tr>
      <RowUI raList={raList} name='currentRatio' />
      <RowUI raList={raList} name='cashRatio' />
      <RowUI raList={raList} name='quickRatio' />
      <RowUI raList={raList} name='netWorkingCapitalToTotalAssets' />
      <tr><td colspan='8'><b>Asset Management</b></td></tr>
      <RowUI raList={raList} name='inventoryTurnover' />
      <RowUI raList={raList} name='inventoryTurnoverInDays' />
      <RowUI raList={raList} name='tradeReceivablesTurnoverRatio' />
      <RowUI raList={raList} name='tradeReceivablesTurnover' />
      <RowUI raList={raList} name='tradePayablesTurnoverRatio' />
      <RowUI raList={raList} name='tradePayablesTurnover' />
      <RowUI raList={raList} name='cashConversion' />
      <RowUI raList={raList} name='netWorkingCapitalTurnoverRatio' />
      <RowUI raList={raList} name='fixedAssetsTurnoverRatio' />
      <RowUI raList={raList} name='totalAssetsTurnoverRatio' />
      <tr><td colspan='8'><b>Leverage Ratios</b></td></tr>
      <RowUI raList={raList} name='debtRatio' />
      <RowUI raList={raList} name='debtContributionRatio' />
      <RowUI raList={raList} name='freeReservesOrEquityRatio' />
      <RowUI raList={raList} name='totalOutsideLiabilityOrTotalNetWorth' />
      <RowUI raList={raList} name='debtOrEbitda' />
      <tr><td colspan='8'><b>Coverage Ratios</b></td></tr>
      <RowUI raList={raList} name='interestCoverageRatio' />
      <RowUI raList={raList} name='cashInterestCoverageRatio' />
      <tr><td colspan='8'><b>Profitability Ratios</b></td></tr>
      <RowUI raList={raList} name='operatingProfitMargin' />
      <RowUI raList={raList} name='netProfitMargin' />
      <RowUI raList={raList} name='ebitdaMargin' />
      <RowUI raList={raList} name='returnOnAssets' />
      <RowUI raList={raList} name='returnOnContribution' />
      <RowUI raList={raList} name='grossCashAccrualMargin' />
      <RowUI raList={raList} name='operatingCashflowMargin' />
      <RowUI raList={raList} name='returnOnCapitalEmployed' />
      <tr><td colspan='8'><b>Growth Ratios</b></td></tr>
      <RowUI raList={raList} name='growthInOperatingCashflowMargin' />
      <RowUI raList={raList} name='growthInDebtOrEquity' />
      <RowUI raList={raList} name='grossCashAccruals' />
      <RowUI raList={raList} name='profitAfterTaxGrowth' />
      <RowUI raList={raList} name='salesGrowth' />
      </tbody>
    </table>
  </div>

const RowUI = ({raList, name}) =>
  <tr>
    <td><Desc name={name} /></td>
    {
      raList.map((bs, i) =>
        <td key={i} className='g_text_right'>
          {bs[name]}
        </td>
      )
    }
  </tr>

  const Desc = ({name}) =>
    <span>
      {(() => {
        switch (name) {
          case 'currentRatio':
          return 'Current Ratio'
          case 'cashRatio':
          return 'Cash Ratio'
          case 'quickRatio':
          return 'Quick Ratio'
          case 'netWorkingCapitalToTotalAssets':
          return 'NWC to Total Assets'
          case 'inventoryTurnover':
          return 'Inventory Turnover Ratio'
          case 'inventoryTurnoverInDays':
          return 'Inventory Turnover (in days)'
          case 'tradeReceivablesTurnoverRatio':
          return 'Trade Receivables Turnover Ratio'
          case 'tradeReceivablesTurnover':
          return 'Trade Receivables Turnover (in days)'
          case 'tradePayablesTurnoverRatio':
          return 'Trade Payables Turnover Ratio'
          case 'tradePayablesTurnover':
          return 'Trade Payables Turnover (in days)'
          case 'cashConversion':
          return 'Cash Conversion (in days)'
          case 'netWorkingCapitalTurnoverRatio':
          return 'NWC Turnover Ratio'
          case 'fixedAssetsTurnoverRatio':
          return 'Fixed Assets Turnover Ratio'
          case 'totalAssetsTurnoverRatio':
          return 'Total Assets Turnover Ratio'
          case 'debtRatio':
          return 'Debt Ratio'
          case 'debtContributionRatio':
          return 'Debt Contribution Ratio'
          case 'freeReservesOrEquityRatio':
          return 'Free Reserves/Equity Ratio'
          case 'totalOutsideLiabilityOrTotalNetWorth':
          return 'Total Outside Liability/Total Net Worth'
          case 'debtOrEbitda':
          return 'Debt/EBITDA'
          case 'interestCoverageRatio':
          return 'Interest Coverage Ratio'
          case 'cashInterestCoverageRatio':
          return 'Cash Interest Coverage Ratio'
          case 'operatingProfitMargin':
          return 'Operating Profit Margin'
          case 'netProfitMargin':
          return 'Net Profit Margin'
          case 'ebitdaMargin':
          return 'EBIDTA Margin'
          case 'returnOnAssets':
          return 'Return on Assets'
          case 'returnOnContribution':
          return 'Return on Contribution'
          case 'grossCashAccrualMargin':
          return 'Gross Cash Accrual Margin'
          case 'operatingCashflowMargin':
          return 'Operating Cashflow Margin'
          case 'returnOnCapitalEmployed':
          return 'Return on Capital Employed'
          case 'growthInOperatingCashflowMargin':
          return 'Growth in Operating Cashflow Margin'
          case 'growthInDebtOrEquity':
          return 'Growth in Debt/Equity'
          case 'grossCashAccruals':
          return 'Gross Cash Accruals'
          case 'profitAfterTaxGrowth':
          return 'Profit after Tax Growth'
          case 'salesGrowth':
          return 'Sales Growth'
          default:
            return name
        }
      })()}
    </span>

export default MCARatioAnalysisUI
